export default "__VITE_ASSET__BbUxX_y1__"